/**
 * @file deleteHistoryService.js
 * @description カスタマイズ設定値履歴の削除を行う共通サービス
 */

import apiService from "../../share/util/api/service";
import { executeSyncRequest } from "../../share/util/api/syncRequest";

/**
 * カスタマイズ設定値履歴を削除する
 * @param {object} self 呼び出し元の this を指定する
 * @param {string} netAppId クラウドコネクターID
 * @param {string} systemId システムID
 * @param {string} selectedId 削除対象のカスタマイズ設定値履歴ID
 * @param {string} regionInfo データソース（master/mirror）
 * @returns {{ validateErrorResult: object; hasUnexpectedError: boolean; }} エラー発生の有無を返す
 * - validateErrorResult: API のレスポンスチェックでエラーが発生した場合の結果（エラーが発生しなかった場合は null）
 * - hasUnexpectedError: API 呼び出しで予期せぬエラーが発生したかどうかのフラグ（true: 発生した、false: 発生しなかった）
 */
export const deleteCustomizeHistory = async (
  self,
  netAppId,
  systemId,
  selectedId,
  regionInfo,
) => {
  let validateErrorResult = null;
  let hasUnexpectedError = false;
  await executeSyncRequest(
    self,
    // DELETE API 呼び出しのコールバック
    async () =>
      await apiService.deleteCall(
        apiService.CST,
        `/netApps/${netAppId}/systems/${systemId}/customize/histories/${selectedId}?region_info=${regionInfo}`,
      ),
    // エラー発生のコールバック
    () => {
      hasUnexpectedError = true;
    },
    // レスポンスチェックはデフォルト処理
    undefined,
    // handler.validate でエラーが発生した場合は、最初の一度だけ保持
    (result) => {
      validateErrorResult = result;
    },
  );

  return { validateErrorResult, hasUnexpectedError };
};
